import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema.ts';

import { getFullName } from './getFullName.ts';

const matchSearchTerm = (searchTerm: string, searchItem: string) => {
  return searchItem
    .trim()
    .toLowerCase()
    .includes(searchTerm.toLowerCase().trim());
};

export const searchFilterJobs = (
  jobs: ScheduleBoardJobModel[],
  searchTerm: string
): ScheduleBoardJobModel[] => {
  return jobs.filter((job) => {
    if (!searchTerm) return true;
    const matchedJobRef = matchSearchTerm(searchTerm, job.orderReference ?? '');
    const matchesLicence = matchSearchTerm(
      searchTerm,
      job.fulfilmentTo?.reference ?? ''
    );
    const customerName = getFullName(job.customer);
    const matchesCustomerName = matchSearchTerm(searchTerm, customerName);

    return matchedJobRef || matchesLicence || matchesCustomerName;
  });
};
